import { FormattedMessage } from 'react-intl';
import { Modal } from '@alltrails/modal';
import styles from './HeatmapPrivacyModal.module.scss';
import HeatmapPrivacyModalContent from './HeatmapPrivacyModalContent';

type Props = {
  isOpen: boolean;
  onCloseRequest: () => void;
};

const HeatmapPrivacyModal = ({ isOpen, onCloseRequest }: Props) => {
  return (
    <Modal
      ariaLabelElementId="heatmap-privacy-modal-title"
      contentsClassName={styles.heatmapPrivacyModal}
      isOpen={isOpen}
      onCloseRequest={onCloseRequest}
      title={<FormattedMessage defaultMessage="About heatmaps" />}
      size="md"
      buttons={{
        primaryButton: {
          onClick: onCloseRequest,
          text: <FormattedMessage defaultMessage="Got it" />,
          testId: 'heatmap-privacy-modal-got-it'
        }
      }}
    >
      <div className={styles.visuallyHidden} id="heatmap-privacy-modal-title">
        <FormattedMessage defaultMessage="About heatmaps" />
      </div>
      <HeatmapPrivacyModalContent />
    </Modal>
  );
};

export default HeatmapPrivacyModal;
